import { FixturesAction } from "./FixturesFooter";
import i18next from "i18next";
import { GridToolbarContainer } from "@mui/x-data-grid-pro";
import { Box, Button, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { PublishedWithChanges as PublishedWithChangesIcon } from "@mui/icons-material";

export const FixturesToolbar = ({
  mode, weekView = false, onSelectAll, onSelectUncompiled,
  handleModeChange,
  forceCompile,
  setSelectionModel,
  setForceCompile,
  selectionModel, handleCompileConfirm, handleEvaluateConfirm,
}) => {
  const clock = (mode === "compile" && (
        <Box sx={{ ml: 0.5 }}>
          <ToggleButton
            size="small"
            value="check"
            selected={forceCompile}
            aria-label={i18next.t("help.dayWorkflow.overrideLabel")}
            title={i18next.t(weekView ? "help.weekWorkflow.clockTooltip" : "help.dayWorkflow.overrideTooltip")}
            onChange={() => {
              setSelectionModel([]);
              setForceCompile(!forceCompile);
            }}
          >
            <PublishedWithChangesIcon />
          </ToggleButton>
        </Box>
      )
  );
  return (
    <GridToolbarContainer sx={{ gap: 1, alignItems: "center" }}>
      {!weekView && <Typography variant="caption" sx={{ fontWeight: 800 }}>
        {i18next.t("help.compilePreview.modeLabel")}
      </Typography>}
      {weekView && mode === "compile" && <Box sx={{display:"flex",alignItems:"center",gap:1}}>
        <Button onClick={onSelectAll}>{i18next.t("help.weekWorkflow.all")}</Button>
        <Button onClick={onSelectUncompiled}>{i18next.t("help.weekWorkflow.uncompiled")}</Button>
      </Box>}
      {weekView && clock}
      {weekView && <FixturesAction {...{selectionModel,mode,handleCompileConfirm,handleEvaluateConfirm}}/>}
      <ToggleButtonGroup
        sx={weekView ? {ml:"auto"} : undefined}
        color="primary"
        value={mode}
        exclusive
        onChange={handleModeChange}
      >
        <ToggleButton
          value="compile"
          title={i18next.t("help.tooltips.compilationMode")}
        >
          {i18next.t("help.dayWorkflow.compileMode")}
        </ToggleButton>
        <ToggleButton
          value="evaluate"
          title={i18next.t("help.tooltips.evaluationMode")}
        >
          {i18next.t("help.dayWorkflow.evaluateMode")}
        </ToggleButton>
      </ToggleButtonGroup>
      {!weekView && clock}
      {!weekView && <FixturesAction {...{selectionModel,mode,handleCompileConfirm,handleEvaluateConfirm}}/>}
    </GridToolbarContainer>
  );
};
